import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['closed', 'open']
  static values = {
    state: { type: String, default: 'closed' },
  }

  connect() {
    this.update()
  }

  show(event) {
    event?.preventDefault()
    this.stateValue = 'open'
  }

  hide(event) {
    event?.preventDefault()
    this.stateValue = 'closed'
  }

  stateValueChanged() {
    this.update()
  }

  update() {
    const isOpen = this.stateValue === 'open'
    if (this.hasClosedTarget) {
      this.closedTarget.classList.toggle('hidden', isOpen)
    }
    if (this.hasOpenTarget) {
      this.openTarget.classList.toggle('hidden', !isOpen)
    }
  }
}
